<template>
  <div class="p-3 bg-white">
    <div id="EditQueueLabelFormContainer" class="vs-con-loading__container">
      <shared-queue-label-edit
        @updateSuccess="updateSuccess"
      ></shared-queue-label-edit>
      <div class="text-center">
        <vs-button id="updateQueueStatusLabelButton" class="m-2" color="primary" type="filled" @click.prevent="update">{{ $t('save') }}</vs-button>
        <vs-button class="m-2 text-dark" color="transparent" type="filled" @click.prevent="cancel">{{ $t('cancel') }}</vs-button>
      </div>
    </div>
  </div>
</template>

<script>

import SharedQueueLabelEdit from '@/views/Shared/Queues/Label/Edit'
import { EventBus } from '@/../eventbus'

export default {
  name: 'Window.Queue.Status.Label.Edit',
  components: {
    SharedQueueLabelEdit
  },
  mounted () {
    this.loadQueueStatus(this.$route.params.id)
  },
  methods: {
    async loadQueueStatus (queueId) {
      EventBus.$emit('initEditQueueStatusLabel', {id: queueId})
    },
    update () {
      EventBus.$emit('initUpdateQueueStatusLabel')
    },
    updateSuccess () {
      this.$windowOpenerHelper.notifyOpener('reload_queue_status_table')
      window.close()
    },
    cancel () {
      this.$windowOpenerHelper.notifyOpener('reload_queue_status_table')
      window.close()
    }
  }
}
</script>

<style scoped>

</style>
